"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar as CalendarIcon, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToStreamline() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const today = new Date();
  return <section data-section-id="171943" id="facility-tour-request" className="relative dark bg-background py-20 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.08]">
        <svg className="absolute inset-0 h-full w-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="blueprint-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#blueprint-grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={cn("max-w-6xl mx-auto transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <Card className="bg-card/50 backdrop-blur-md dark:bg-card/40 border-white/10 shadow-2xl overflow-hidden rounded-2xl md:rounded-3xl">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              
              {}
              <div className="p-8 md:p-12 lg:pr-0 flex flex-col items-start">
                <div className="inline-flex items-center justify-center p-3.5 bg-primary/20 rounded-xl mb-6 shadow-sm border border-primary/20">
                  <SafeHydrate><CalendarIcon className="w-7 h-7 text-primary" /></SafeHydrate>
                </div>
                
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-semibold text-foreground mb-5 tracking-tighter">
                  See Our Precision in Action
                </h2>
                
                <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-lg leading-relaxed">
                  Book a private walkthrough of our FDA-registered facility to explore our high-speed canning lines and custom formulation labs.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                  <Button size="lg" asChild className="text-base h-14 px-8 shadow-lg hover:shadow-primary/20 bg-primary text-primary-foreground hover:bg-primary/90 transition-all group rounded-full">
                    <Link to="/ContactPage">
                      Schedule Facility Tour
                      <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </div>
                
                <div className="mt-8 flex items-center gap-3 text-sm text-muted-foreground font-mono">
                  <div className="flex -space-x-2">
                    <div className="w-8 h-8 rounded-full bg-primary/20 border-2 border-card flex items-center justify-center text-[10px] font-bold text-primary">QC</div>
                    <div className="w-8 h-8 rounded-full bg-chart-3/20 border-2 border-card flex items-center justify-center text-[10px] font-bold text-chart-3">RD</div>
                  </div>
                  <p className="tracking-wide uppercase">Trusted by leading wellness and RTD brands.</p>
                </div>
              </div>

              {}
              <div className="p-8 md:p-12 lg:pl-0 flex justify-center lg:justify-end relative">
                {}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-br from-primary/20 to-transparent rounded-full blur-3xl -z-10" />
                
                <div className="relative group">
                  {}
                  <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary/10 rounded-full blur-2xl transition-all group-hover:bg-primary/20" />
                  <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-chart-3/10 rounded-full blur-2xl transition-all group-hover:bg-chart-3/20" />
                  
                  {}
                  <div className="bg-card border border-white/10 shadow-xl rounded-2xl p-2 transform rotate-2 hover:rotate-0 transition-all duration-500 hover:shadow-2xl relative z-10">
                    <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent rounded-2xl pointer-events-none" />
                    <SafeHydrate><Calendar mode="single" selected={today} className="rounded-xl bg-transparent pointer-events-none text-foreground" classNames={{
                      day_today: "bg-primary text-primary-foreground font-bold rounded-md",
                      head_cell: "text-muted-foreground font-mono text-xs uppercase"
                    }} /></SafeHydrate>
                  </div>
                </div>
              </div>

            </div>
          </Card>
        </div>
      </div>
    </section>;
}